const BASE_URL = "https://backend.credfin.money/v1/";
const CRIF_URL = "https://bre.infitouch.in/";
// const CRIF_URL = "http://192.168.1.36:8060/";

const APIS = {
    EMPLOYEE_LOGIN: BASE_URL + "empoyeeLogin?email=" ,
    GET_AMU_CRIF_REPORT: BASE_URL + "getAMUCrifReport?empId=" ,
    SEND_AMU_OTP_BY_MOBILE_NUMBER: BASE_URL + "sendAMUOTP?mobile=" ,
    VERIFY_AMU_OTP_BY_MOBILE_NUMBER: BASE_URL + "getAMUOTP?mobile=" ,
    GET_AMU_ANALYSIS: BASE_URL + "getAMUAnalysis" ,
    GET_USER_DATA_FOR_SCORE_ANALYSIS: BASE_URL + "getUserDataForScoreAnalysis?userId=" ,
    GET_CRIF_DATA: BASE_URL + "generateAMUCrif?userId=" ,

    IS_CRIF_GENERATED: CRIF_URL + "isCrifGenerated?userId=" ,
    GET_CRIF_SIMILARITY: CRIF_URL + "getCrifSimilarityWithUserInfo?userId=" ,
    GET_CRIF_DATA_V2: CRIF_URL + "getCrifDataLV3?userId=" ,
    GET_CRIF_ANALYSIS_V2: CRIF_URL + "getCrifAnalysisV2?userId=" ,
    GET_DETAILS_FROM_APP_ID: CRIF_URL + "getDetailsFromAppId?appId=" ,
}


export {
    APIS,
    BASE_URL
}